import { CONTAINER_WIDTH } from './DraggableQuickFilter';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function EmptySlot({
  buttonHeight
}) {
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    blockSize: `${buttonHeight}px`,
    inlineSize: `${CONTAINER_WIDTH}px`,
    borderWidth: "100",
    borderStyle: "dashed",
    borderColor: "border-core-subtle",
    borderRadius: "100"
  });
}
export default EmptySlot;